<template>
  <a-card :bordered="false" class="m-b-20">
    <a-form  :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" :disabledDate="disabledDate"  valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        <a-week-picker v-else-if="search.search_date_type=='2'" @change="changeWeek" v-model:value="weekTime" :disabledDate="disabledDate"  />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" valueFormat='YYYY-MM' format='YYYY-MM' :disabledDate="disabledDate"  />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <div ref="echartsLine" style="width:100%;height:400px"></div>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <div class="s_flex_ali">
      <div style="width:50%">
        <div ref="echartsPie1" style="width:100%;height:400px"></div>
      </div>
      <div style="width:50%">
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns1' :data-source='chartListProduct'>
             <template v-slot:ranking="{ record ,index}">
            {{record.ranking}}  <span :style="'display: inline-block;width:20px;height:10px;background-color:'+color[index]" ></span>
         </template>
        </a-table>
      </div>
    </div>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <div class="s_flex_ali">
      <div style="width:50%">
        <div ref="echartsPie2" style="width:100%;height:400px"></div>
      </div>
      <div style="width:50%">
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns2' :data-source='chartListPosition'>
             <template v-slot:ranking="{ record ,index}">
            {{record.ranking}} <span :style="'display: inline-block;width:20px;height:10px;background-color:'+color[index]" ></span>
         </template>
        </a-table>
      </div>
    </div>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
   <a-form class='m-b-20'  :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="入库仓库" name='warehouse_id' >
        <a-select v-model:value="form.warehouse_id"  placeholder='请选择仓库' style="width:150px" @change='selectChange' :disabled="$route.query.type == 'edit' || isDisabled">
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="库位" name='position_id' v-if="form.warehouse_id" >
        <a-select v-model:value="form.warehouse_position_name" placeholder='请选择库位' style="width:150px" >
          <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.name">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="商品名称" >
          <a-input  v-model:value="form.product_name" placeholder="请输入关键词进行搜索" />
      </a-form-item>
        <a-form-item label="规格" >
          <a-input  v-model:value="form.product_sku_name" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false'  bordered  :columns='analyzeColumns' :data-source='detail.list'>
        <template v-slot:ranking="{ record ,index}">
            {{record.ranking}} <span :style="'width:20px;height:10px;background-color:'+color[index]" ></span>
         </template>
      <template v-slot:action="{ record }">
        <a href="javascript:;" @click="$router.push({path:'/antiFleeingGoods/statistics/dealerAnalyze',query:{'dealer_sn':record.dealer_sn,'dealer_name':record.dealer_name,'search_time':search.search_time,'search_date_type':search.search_date_type}})">查看分析</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { generalDeadProduct,getWarehouseList } from "@/api/antiFleeing";
import { message } from "ant-design-vue";
import { iscode } from '../../../../utils/app';

export default {
  components: {},
  setup() {
    const momentTime = inject("momentTime");
    const search = ref({
      search_date_type: "1",
      start_time: "",
      total:0,
      limit:10,
      pages:1,
      end_time: "",
      type: 1,
      product_sn: "",
      product_sku_sn: "",
    });
    const state = reactive({
      list: [],
      total: 0,
      chartListProduct: [],
      line: [],
      chartListPosition: [],
      detail: {list:[]},
      color: ["#02a7f0","#ffc000", "#70b603", "#8080ff", "#f59a23", "#f59a23",'#a5a5a5'],
      warehouseList:[],
           disabledDate:function(current) {
        return current && current > momentTime().subtract(0, 'days').endOf('day')
      },
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      changNav();
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          break;
        case "2":
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          break;
        case "4":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
      }
    };
    // 切换周
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    let columns1 = [
      {
        title: "排名",
        dataIndex: "ranking",
        key: "ranking",
         slots: { customRender: "ranking" },
      },
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
      },
      {
        title: "商品规格",
        dataIndex: "product_sku_name",
        key: "product_sku_name",
      },
      {
        title: "占比",
        dataIndex: "value",
        key: "value",
      },
    ];
    let columns2 = [
      {
        title: "排名",
        dataIndex: "ranking",
        key: "ranking",
        slots: { customRender: "ranking" },
      },
      {
        title: "仓库名称",
        dataIndex: "warehouse_name",
        key: "warehouse_name",
      },
      {
        title: "呆滞品数量",
        dataIndex: "code_num",
        key: "code_num",
      },
      {
        title: "占比",
        dataIndex: "value",
        key: "value",
      },
    ];
    let analyzeColumns=[
       {
        title: "所在仓库",
        dataIndex: "warehouse_name",
        key: "warehouse_name",
      },
      {
        title: "所在仓位",
        dataIndex: "warehouse_position_name",
        key: "warehouse_position_name",
      },
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
      },
      {
        title: "规格",
        dataIndex: "product_sku_name",
        key: "product_sku_name",
      }, {
        title: "呆滞品数量",
        dataIndex: "code_num",
        key: "code_num",
      },
    ]
    var $moment = inject("momentTime");
    var $route = inject("$route");
    const form=ref({
      warehouse_id:undefined,
      warehouse_name:"",
      warehouse_position_name:'',
      product_name:'',
      product_sku_name:'',
    })
    const getLine = async () => {
      switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case "2":
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case "3":
          search.value.start_time = $moment(search.value.search_time)
            .startOf("month")
            .format("YYYY-MM-DD");
          search.value.end_time = $moment(search.value.search_time)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
      console.log({
        ...search.value,
        ...form.value
      })
      let result = await generalDeadProduct({
        ...search.value,
        ...form.value
      })
        .then((res) => res.data)
        .catch((error) => error);
      // 整理数据
      var chartsList = [];
      state.detail = result.data;
      state.total = result.data.total;
      var chartListProduct = [];
      var productTotal =result.data.code_num_total;
      var productTop5Total = 0;
      result.data.chartListProduct.forEach((element, k) => {
        productTop5Total += element.code_num;
        chartListProduct.push({
          ranking: k + 1,
          name: element.product_name+element.product_sku_name,
          ...element,
          value: ((element.code_num / productTotal) * 100).toFixed(1),
        });
      });
      state.detail.chartListProduct = chartListProduct;
      if (productTop5Total < productTotal) {
        chartListProduct.push({
          name: "其它",
          value:( ((productTop5Total - productTotal) / productTotal) * 100).toFixed(1),
        });
      }
      state.chartListProduct = chartListProduct;
      // chartListPosition
      var chartListPosition = [];
      var chartListPositionTotal = result.data.code_num_total;
      var chartListPositionTop5Total = 0;
      result.data.chartListPosition.forEach((element, k) => {
        chartListPositionTop5Total += element.code_num;
        chartListPosition.push({
          ranking: k + 1,
          name: element.warehouse_name,
          ...element,
          value: ((element.code_num / productTotal) * 100).toFixed(1),
        });
      });
      state.detail.chartListPosition = chartListPosition;
      if (chartListPositionTop5Total < chartListPositionTotal) {
        chartListPosition.push({
          name: "其它",
          value:( ((chartListPositionTop5Total - chartListPositionTotal) /
              chartListPositionTotal) *
            100).toFixed(1),
        });
      }
      state.chartListPosition = chartListPosition;
      //  line
      state.line = result.data.lineList;
      return chartsList;
    };

    // 折线图
    const echartsLine = ref("");
    const echartsPie2 = ref("");
    const echartsPie1 = ref("");
    var line;
    var pie1;
    var pie2;
    const changNav = async () => {
     await getLine();
      line.setOptions({
        title: {
          text: "前6天呆滞品数量趋势图",
        },
        xAxis: {
          type: "category",
          data: state.line.map((v) => v.date),
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "axis",
          formatter: "商品销量：{c}%",
        },
        series: [
          {
             color: state.color,
            data: state.line.map((v) => v.code_num),
            type: "line",
            smooth: true,
            areaStyle: {},
          },
        ],
      });
      pie1.setOptions({
        title: {
          text: "TOP5呆滞商品占比",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/>占比：{c}%",
        },
        series: [
          {
            color: state.color,
            type: "pie",
            radius: ['40%', '70%'],
            data: state.chartListProduct || [],
          },
        ],
      });
      pie2.setOptions({
        title: {
          text: "TOP5呆滞仓库占比",
          left: "center",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/>占比：{c}",
        },
        series: [
          {
            type: "pie",
            radius: ['40%', '70%'],
            data: state.chartListPosition || [],
            color: state.color,
          },
        ],
      });
    };

          // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
        //选择仓库
      const selectChange = () =>{
        form.value.position_id = null
        var item = state.warehouseList.find(v => v.id == form.value.warehouse_id)
        console.log(item)
        form.value.warehouse_name=item.name
        state.warehouseChild = item.child || []
      }
         // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
       changNav(1);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
           changNav(1);
    };
    onMounted(() => {
      handleChange("1");
      line = useECharts(echartsLine.value);
      pie1 = useECharts(echartsPie1.value);
      pie2 = useECharts(echartsPie2.value);
      getWarehouse()
      changNav(1);
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      pageCurrentChange,
      pageSizeChange,
      selectChange,
      handleChange,
      changNav,
      onSearch,
      changeWeek,
      columns1,
      columns2,
      echartsLine,
      echartsPie1,
      echartsPie2,
      form,
      analyzeColumns
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.active {
  border: 1px solid #bbddff;
  box-shadow: 7px 5px 22px 0px #9cb9d7;
  position: relative;
  left: -5px;
  top: -5px;
}
</style>